export default __webpack_public_path__ + "static/char-v-15-9fee2b572a66fb6580ca40fbfefd4eee.png";